import React from "react";
import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";

export default function NoResultsFound() {
  return (
    <p
      css={{
        fontSize: 14,
        color: palette.mediumGray,
      }}
    >
      <FormattedMessage defaultMessage="Sorry, no results found." id="Lpps9D" />
    </p>
  );
}
